import { ref, watch, computed } from '@vue/composition-api'
import axios from '@axios'
import useAuth from '@/auth/useAuth'
import { useUtils as useI18nUtils } from '@core/libs/i18n';
const { i18n } = useI18nUtils();
function i18nT(str){
    return i18n(str)
  };
export default function useSurveyList() {
  const refDocumentListTable = ref(null)

  // Table Handlers
  const tableColumns = [
    { key: 'checkbox', label: '', thClass: 'tbl-chk', tdClass: 'tbl-chk' },
    { key: 'name', label: i18nT(`Employee`), thClass: 'pl-1', tdClass: 'pl-1' },
    { key: 'day', label: i18nT(`Day`), sortable: true },
    { key: 'totalHours', label: i18nT(`Total hours`), sortable: true, thClass: "sk-header-content" },
    { key: 'paid', label: i18nT(`Paid`), sortable: true },
    { key: 'status', label: i18nT(`Status`), sortable: true },
    {
      key: 'action',
      label: i18nT(`Actions`),
      thClass: 'tbl-actions',
      tdClass: 'sticky-column',
      stickyColumn: true
    },
  ]
  const perPage = ref(10)
  const totalDocuments = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)
  const from = ref('')
  const to = ref('')
  const status = ref('')
  const type = ref('')
  const employee = ref('')
  const requests = ref([])

  const dataMeta = computed(() => {
    const localItemsCount = refDocumentListTable.value
      ? refDocumentListTable.value.localItems.length
      : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalDocuments.value,
    }
  })

  const refetchData = () => {
    refDocumentListTable.value.refresh()
  }

  watch(
    [currentPage, perPage, searchQuery, from, to, status, type, employee],
    () => {
      refetchData()
    }
  )

  const fetchRequests = (ctx, callback) => {
    const curWorkspace = useAuth.getCurWorkspace()

    const params = {
      page: currentPage.value,
      show_per_page: perPage.value,
      sort_by: sortBy.value,
      sort_order: isSortDirDesc.value ? 'DESC' : 'ASC',
      search: searchQuery.value,
    }

    if (status.value != null) {
      params['filters[status]'] = status.value
    }
    if (to.value != null) {
      params['filters[end_date]'] = to.value
    }
    if (from.value != null) {
      params['filters[start_date]'] = from.value
    }
    if (employee.value != null) {
      params['filters[employee]'] = employee.value
    }

    axios
      .get(`timesheets`, {
        params,
      })
      .then(({ data }) => {
        requests.value = data.data.timesheets
        callback(data.data.timesheets)
        totalDocuments.value = data.data.pagination.records_count
      })
  }

  return {
    fetchRequests,
    tableColumns,
    perPage,
    currentPage,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refDocumentListTable,
    totalDocuments,
    from,
    to,
    status,
    type,
    employee,
    requests,
    refetchData,
  }
}
